export default __webpack_public_path__ + "static/media/css-3_official.ee522735.svg";